exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cell {\n  width: 35px;\n  height: 35px;\n  margin: 2px;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.cell .square {\n  width: 34px;\n  height: 34px;\n  background: rgb(253, 253, 253);\n  transition: background 0.5s;\n  border: 1px solid #999;\n  border-radius: 10px;\n}\n\n.cell .square .cellOverlay {\n  height: 100%;\n  width: 100%;\n  display: inline-block;\n  border-radius: 10px;\n  transition: background 0.5s;\n}\n\n.cell .square:hover .cellOverlay {\n  background: rgba(50, 110, 240, 0.3);\n}\n\n.cell .square .cellOverlay .cdot{\n  width: 10px;\n  height: 10px;\n  margin: 12px;\n  border-radius: 20px;\n  transform: scale(0.1);\n  transition: transform 0.5s;\n}\n\n.cell .square:hover .cellOverlay .cdot{\n  transform: scale(1);\n  background: rgb(40, 100, 235);\n}\n\n.square.isOn {\n  background: rgb(50, 50, 50);\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/css/Square.css
// module id = 92
// module chunks = 0